import { registerUkhabExpressions } from '../ukhab/expressions/registerUkhabExpressions';

export const registerExpressionNamespaces = (): void => {
  registerUkhabExpressions();
};
